var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16.5,
    viewBox: "0 0 22 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.583,69.448a.259.259,0,0,1,.417.2v8.787A2.063,2.063,0,0,1,19.937,80.5H2.063A2.063,2.063,0,0,1,0,78.438V69.655a.257.257,0,0,1,.417-.2c.963.748,2.239,1.7,6.621,4.881C7.945,75,9.475,76.388,11,76.379c1.534.013,3.094-1.409,3.966-2.045C19.349,71.15,20.621,70.2,21.583,69.448ZM11,75c1,.017,2.432-1.255,3.154-1.779,5.7-4.138,6.136-4.5,7.451-5.53a1.028,1.028,0,0,0,.4-.812v-.816A2.063,2.063,0,0,0,19.937,64H2.063A2.063,2.063,0,0,0,0,66.063v.816a1.035,1.035,0,0,0,.4.812c1.315,1.027,1.749,1.392,7.451,5.53C8.568,73.745,10,75.017,11,75Z",
    transform: "translate(0 -64)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2dbc08fd.svg";
export { ForwardRef as ReactComponent };